<template>
  <router-btn v-if="userTypeId == 1 || userTypeId == 2" :text="$t('servicesystem.common_objects.job.new')" :icon="'mdi-plus'"
    :color="'primary'" :disabled="false" :outlined="false" :textbtn="textbtn" :large="large" :small="small"
    @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "NewJobBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  methods: {
    action() {
      var routeName = this.customerId ? 'NewJobOverview' : 'NewJobStart';
      var routeParams = { filter: "my" };
      var routeQuery = {
        customerId: this.customerId ?? undefined,
        machineId: this.machineId ?? undefined,
        picker: this.machineId ? undefined : 'machine'
      };

      this.$router.push({ name: routeName, params: routeParams, query: routeQuery });
    },
  },

  computed: {
    userTypeId() {
      return this.userInfo?.UserTypeId;
    },
        
    customerId() {
      if (this.$route.name == 'MachineJobs') {
        var machine = this.$store.getters["entitycontainerstore/getEntity"]('Machine');
        return machine?.CustomerId;
      }
      else {
        return this.$route.params?.customerId || this.$route.query?.customerId;
      }
    },

    machineId() {
      return this.$route.params?.machineId || this.$route.query?.machineId;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
